import {PaymentMethod} from "../enums/paymentMethod";

export class PaymentTransactionRequest {
  paymentMethod: PaymentMethod;
  description: string;
  toUserId: bigint | null;
  userCardId: string | null;
  amount: number;
  validDays: number;
  username: string | null;
  commission: number;
  moneyLuxUuid: string | null;
  productOrderId?: number | null;
  product?: string | null;

  constructor(paymentMethod: PaymentMethod, description: string, toUserId: bigint | null,
              userCardId: string | null, amount: number, validDays: number, username: string | null,
              commission: number, moneyLuxUuid: string | null, productOrderId?: number | null, product?: string | null) {
    this.paymentMethod = paymentMethod;
    this.description = description;
    this.toUserId = toUserId;
    this.userCardId = userCardId;
    this.amount = amount;
    this.validDays = validDays;
    this.username = username;
    this.commission = commission;
    this.moneyLuxUuid = moneyLuxUuid;
    this.productOrderId = productOrderId;
    this.product = product;
  }
}
